import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="sso"
export default class extends Controller {
  static targets = ['googleLoadingButton']
  googleLoadingButtonTargetConnected() {
    // Google SSO button is set up as a post request that will fire when clicked
    // we want to auto-click the button for them in this case
    setTimeout(() => {
      this.googleLoadingButtonTarget.click()
    }, 3000) // Delay of 3 seconds
  }
}
